<template>
  <div class="pb-6 md:pb-10 border-b-[3px] text-center mb-10 lg:mb-14">
    <h1
      class="text-3xl md:text-4xl lg:text-5xl font-benton font-medium text-brown"
    >
      <slot />
    </h1>
  </div>
</template>
